export default "__VITE_ASSET__xZ0zzJa9__"